export default __webpack_public_path__ + "static/media/placeholder_business02-en-web.3c90230c.png";